const SCREEN_HEIGHT = window.innerHeight;
const SCREEN_WIDTH = window.innerWidth;

export { SCREEN_HEIGHT, SCREEN_WIDTH };
